export default "__VITE_ASSET__DoxfRM2s__"